<template minapp='mpx' xlang='wxml'>
  <wxs module="tools">
    var btnStyle = function(mode,curMode) {
      if(mode == curMode){
        return {
          'background': '#1473FF',
          'color':'#ffffff'
        }
      }
      return {
        'background': '#FFFFFF',
        'color':'#333333'
      }
    }

    module.exports = {
      btnStyle: btnStyle,
    };
  </wxs>
  <view class="change-box" bindtap="changeModel">
    <view class="change-box-CN" wx:style="{{tools.btnStyle('Chinese',innerValue)}}">
      中
    </view>
    <view class="change-box-ENG" wx:style="{{tools.btnStyle('english',innerValue)}}">
      EN
    </view>
  </view>
</template>

<script>
import { watch } from "@mpxjs/core";
import { createComponent } from '@didi/es-mpx-creator'

createComponent({
  classes: [],
  data: {
    innerValue:'Chinese',
  },
  props: {
    value:{
      type: String,
      value: 'Chinese'
    },
    isShow:{
      type: Boolean,
      value: false
    }
  },
  computed: {
    
  },
  methods: {
    changeModel(){
      if(this.innerValue === 'Chinese'){
        this.innerValue = 'english'
      }else{
        this.innerValue = 'Chinese'
      }
    }
  },
  watch:{
    value(val) {
      this.innerValue = val
    },
    //将数据回传
    innerValue(newValue) {
      this.$trigger( 'input', {value:newValue} )
    },
  }
})
</script>

<style lang='stylus' scoped>
.change-box
  width: 74px;
  height: 22px;
  background: #FFFFFF;
  border: 1px solid #E5E5E5;
  border-radius: 6px;
  display: flex;
  font-family: PingFangSC-Regular;
  font-size: 12px;
.change-box-CN
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 22px;
  background: #1473FF;
  border-radius: 6px;
  color: #FFFFFF;
.change-box-ENG
  width: 38px;
  height: 22px;
  border-radius: 6px;
  display: flex
  align-items: center;
  justify-content: center;
</style>

<script name='json'>
  module.exports = {
    component: true,
    "usingComponents": {
    }
  }
</script>

